import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { DOMSerializer } from 'prosemirror-model';

import { type ADFDocument } from '@canvas/adf-types';

import { createEnhancedSchema } from './create-enhanced-schema';

const transformer = new JSONTransformer();
const schema = createEnhancedSchema();
const serializer = DOMSerializer.fromSchema(schema);

export function adfDocumentToHtml(adf: ADFDocument): string {
  try {
    const doc = { version: 1, type: 'doc' as const, content: adf.content ?? [] };
    const pmNode = transformer.parse(doc);
    const fragment = serializer.serializeFragment(pmNode.content);
    const div = document.createElement('div');
    div.appendChild(fragment);
    return div.innerHTML;
  } catch {
    return '';
  }
}
